export const handleInput = (e, wordCheck) => {
  wordCheckEvent(e, wordCheck);
};

export const wordCheckEvent = (e, type) => {
  const { value } = e.target;
  let pattern;

  switch (type) {
    case "eng":
      pattern = /[^A-Za-z0-9_]/g;
      break;
    case "password":
      pattern = /[^A-Za-z0-9!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?`~]/g;
      break;
    case "number":
      pattern = /[^0-9]/g;
      break;
    default:
      pattern = null;
  }

  const filteredValue = pattern ? value.replace(pattern, "") : value;
  e.target.value = filteredValue;

  return filteredValue;
};

export const alertCheck = (e) => {
  const target = e.target;
  const alertMessage = document.getElementById(`${target.id}Alert`);

  if (target.value.length === 0) {
    alertMessage.classList.add("active");
  } else {
    alertMessage.classList.remove("active");
  }
};